import React, { useCallback } from 'react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useModal } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import TWIABuildingLocationAccordion from '../TWIABuildingSummaryAccordions/TWIABuildingLocationAccordion/TWIABuildingLocationAccordion';
import TWIABuildingInfoAccordion from '../TWIABuildingSummaryAccordions/TWIABuildingInfoAccordion/TWIABuildingInfoAccordion';
import TWIABuildingConstructionAccordion from '../TWIABuildingSummaryAccordions/TWIABuildingConstructionAccordion/TWIABuildingConstructionAccordion';
import TWIABuildingCoveragesAccordion from '../TWIABuildingSummaryAccordions/TWIABuildingCoveragesAccordion/TWIABuildingCoveragesAccordion';
import TWIABuildingAdditionalInterestsAccordion from '../TWIABuildingSummaryAccordions/TWIABuildingAdditionalInterestsAccordion/TWIABuildingAdditionalInterestsAccordion';

import metadata from './TWIAViewBuilding.metadata.json5';
import DeleteBuildingMessageUtil from '../../util/DeleteBuildingMessageUtil';

function TWIAViewBuilding({location, building, backAction,handleEditLinkClick, handleDeleteBuildingState, submissionVM,setHasBuildingList,
    setBuildingList,
    getBuildingsFromLocations, wizardStep,showLocationAccordion,
    showBuildingAccordion,
    showConstructionAccordion,
    showCoverageAccordion, showAdditionalInterestAccordion, updateWizardData}) {
    const { showConfirm } = useModal();
    const { authHeader } = useAuthentication();
    const isPolicyChange = _.get(submissionVM, 'baseData.jobType.value.code') === "PolicyChange";

    // DE15808
    const deletesBuilding = useCallback(() => {
        DeleteBuildingMessageUtil.deleteBuilding(building, submissionVM, showConfirm, authHeader, setHasBuildingList, setBuildingList,
            getBuildingsFromLocations, backAction, updateWizardData); // DE18583

    }, [])

    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal'
    const coverageForm = _.get(building, 'coverageForm')

    
    const resolvers = {
        resolveCallbackMap: {
            backAction,
            deletesBuilding,
            handleDeleteBuildingState
        },
        resolveComponentMap: {
            TWIABuildingLocationAccordion,
            TWIABuildingInfoAccordion,
            TWIABuildingConstructionAccordion,
            TWIABuildingCoveragesAccordion,
            TWIABuildingAdditionalInterestsAccordion
        }
    }

    const overrideProps = {
        buildingTitle: {
            content: _.get(building, 'description') || _.get(building, 'name')
        },
        locationAccordion: {
            visible:showLocationAccordion,
            location,
            handleEditLinkClick,
            wizardStep
        },
        buildingAccordion: {
            visible:showBuildingAccordion,
            building,
            handleEditLinkClick,
            wizardStep
        },
        constructionAccordion: {
            visible:showConstructionAccordion,
            building,
            handleEditLinkClick,
            wizardStep
        },
        coveragesAccordion: {
            visible:showCoverageAccordion,
            isBuildingSummary: true,
            handleEditLinkClick,
            wizardStep,
            fromBuilding : true
        },
        additionalInterestsAccordion: {
            visible: showAdditionalInterestAccordion,
            handleEditLinkClick,
            wizardStep,
            submissionVM,
            buildingId: building?.publicID,
        },
        // US26385
        deleteIcon: {
            visible: isPolicyChange && coverageForm === 'TWCR' ? false : !((coverageForm === 'TWCR' && isRenewal)) // DE17044
        }
    }

    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={building}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    )
}

export default TWIAViewBuilding